import React from 'react';
import { TimePicker } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const SimpleTimePicker = ({ 
  value, 
  onChange, 
  placeholder = "选择时间",
  className = "",
  size = "middle",
  disabled = false
}) => {
  const dayjsValue = value ? dayjs(value, 'HH:mm') : null;

  const handleChange = (time) => {
    if (time) {
      onChange(time.format('HH:mm'));
    } else {
      onChange('');
    }
  };

  return (
    <TimePicker
      value={dayjsValue}
      onChange={handleChange}
      format="HH:mm"
      placeholder={placeholder}
      className={className}
      size={size}
      disabled={disabled}
      suffixIcon={<ClockCircleOutlined />}
      style={{ width: '100%' }}
    />
  );
};

export default SimpleTimePicker;
